// src/components/shell/Sidebar/SidebarLogo.tsx
// Top-of-rail brand mark. Not clickable per the doctrine.
// When the sidebar is collapsed only the logo glyph (or initials) shows;
// when expanded the brand name appears next to it.
import { useOrgSettings } from "@/hooks/useOrgSettings";

export type SidebarLogoProps = {
  expanded: boolean;
};

function initialsFromName(name: string): string {
  const cleaned = name.trim();
  if (!cleaned) return "•";
  const parts = cleaned.split(/\s+/).slice(0, 2);
  return parts.map((p) => p.charAt(0).toUpperCase()).join("");
}

export function SidebarLogo({ expanded }: SidebarLogoProps) {
  const { brandName, appDisplayName, logoUrl } = useOrgSettings();
  const displayName = (brandName || appDisplayName || "App").trim();
  const initials = initialsFromName(displayName);

  return (
    <div
      className="flex items-center gap-3 px-3 py-3 select-none"
      aria-label={displayName}
      title={expanded ? undefined : displayName}
    >
      <div className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-indigo-500 to-emerald-500 text-sm font-bold text-white shadow-sm">
        {logoUrl ? (
          <img
            src={logoUrl}
            alt=""
            className="h-9 w-9 rounded-xl object-contain"
            onError={(e) => {
              (e.target as HTMLImageElement).style.display = "none";
            }}
          />
        ) : (
          <span aria-hidden>{initials}</span>
        )}
      </div>
      {expanded ? (
        <span className="truncate text-sm font-semibold text-gray-800 dark:text-gray-100">
          {displayName}
        </span>
      ) : null}
    </div>
  );
}
